module.exports = __webpack_public_path__ + "img/facebook.a4e19d84.svg";